define(function(require, exports, module) {
    'use strict';

    const i18n = require('i18n');
    const _ = require('underscore');
    const userValidationConfig = require('modules/user/user.validation.config');

    module.exports = () => {
        const initialUserValidationConfig = userValidationConfig();
        const { password } = initialUserValidationConfig;
        const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!#$%^&*()\-+@№:|\\±<>?])[a-zA-Z0-9!#$%^&*()\-+@№:|\\±<>?]{8,20}$/;

        const datePickerPrepareData = ($inputs) => {
            const date = $inputs
                .map(input => input.name.replace(/_.+/g, ''))
                .reduce((result, name, index) => {
                    result[name] = parseInt($inputs[index].value);

                    return result;
                }, {});

            const areAllInputsFilled = _.values(date).every(datePart => !_.isNaN(datePart));

            return { date, areAllInputsFilled };
        };

        const adultDateCheck = (data) => {
            const minAge = 21;
            const adultDate = new Date(data.date.year + minAge, data.date.month - 1, data.date.day);

            return adultDate <= new Date();
        };

        const dateOfBirthValidateFn = ($inputs, { isBirthdateRequired } = {}) => {
            const data = datePickerPrepareData($inputs);

            if (!isBirthdateRequired && data.areAllInputsEmpty) {
                return true;
            }

            if (!data.areAllInputsFilled) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.birthdate.required');

                return false;
            }

            return adultDateCheck(data);
        };

        return {
            ...initialUserValidationConfig,
            password: {
                ...password,
                regexp: {
                    regexp: passwordRegex,
                    message: i18n.t('playtech.mobile.system.user.tooltip.password.regexp')
                }
            },
            birthdate: {
                fn: {
                    fn: function($inputs, config, form) {
                        const isBirthdateRequired = form?.options?.isBirthdateRequired;

                        return dateOfBirthValidateFn.call(this, $inputs, { isBirthdateRequired });
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.birthdate.fn')
                }
            },
            dateOfBirth: {
                fn: {
                    fn: function($inputs) {
                        return dateOfBirthValidateFn.call(this, $inputs);
                    },
                    message: i18n.t('playtech.mobile.system.user.tooltip.birthdate.fn')
                }
            },
            firstname: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.firstname.required')
                },
                length: {
                    min: 1,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.firstname.length')
                },
                regexp: {
                    regexp: /^[a-zA-Z\s'\-]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.firstname.regexp')
                }
            },
            lastname: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.lastname.required')
                },
                length: {
                    min: 1,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.lastname.length')
                },
                regexp: {
                    regexp: /^[a-zA-Z\s'\-]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.lastname.regexp')
                }
            },
            address: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.required')
                },
                length: {
                    min: 1,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.length')
                },
                regexp: {
                    regexp: /^[A-Za-z0-9\s'\-,.#]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.address.regexp')
                }
            },
            city: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.required')
                },
                length: {
                    min: 1,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.length')
                },
                regexp: {
                    regexp: /^[A-Za-z0-9\s'\-,.]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.city.regexp')
                }
            },
            zip: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.required')
                },
                length: {
                    min: 5,
                    max: 10,
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.length')
                },
                regexp: {
                    regexp: /^[0-9\-]+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.zip.regexp')
                }
            },
            ssn: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.ssn.required')
                },
                regexp: {
                    regexp: /^[0-9]{4}$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.ssn.regexp')
                }
            },
            email: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.required')
                },
                length: {
                    min: 1,
                    max: 50,
                    message: i18n.t('playtech.mobile.system.user.tooltip.email.length')
                },
                email: true
            },
            // forgot password recovery verification answer
            forgotPasswordAnswer: {
                required: true
            },
            passwordVerify: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.passwordVerify.required')
                },
                fn: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.passwordVerify.required'),
                    fn: function($inputs, config, form) {
                        const passwordVerifyValue = $inputs.val();
                        const passwordValue = form.$el.find('input[name="password"]').val();

                        if (!/^[A-Za-z0-9.@_#$'&+()*`;!?,-\/]+$/.test(passwordVerifyValue)) {
                            this.message = i18n.t('playtech.mobile.system.user.tooltip.password.regexp');
                            return false;
                        }

                        return passwordValue !== '' ? passwordVerifyValue === passwordValue : true;
                    }
                }
            },
            phoneWithArea: {
                required: {
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.required')
                },
                regexp: {
                    regexp: /^(\d|-)+$/,
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.fn')
                },
                fn: {
                    fn: $inputs => $inputs[0].value.trim().replace(/-/g, '').length === 10,
                    message: i18n.t('playtech.mobile.system.user.tooltip.phoneWithArea.length')
                }
            },
        };
    };
});
